import React, { ReactNode, useReducer } from 'react';

import { searchByMlsNumberSubmit } from './searchByMlsNumber.actions';
import {
  SearchByMlsNumberContext,
  searchByMlsNumberState,
} from './SearchByMlsNumber.context';
import { searchByMlsNumberReducer } from './searchByMlsNumber.reducer';

export const SearchByMlsNumberProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, dispatch] = useReducer(
    searchByMlsNumberReducer,
    searchByMlsNumberState,
  );
  return (
    <SearchByMlsNumberContext.Provider
      value={{
        state,
        onSubmit: (queryId: string, v: string) => {
          dispatch(searchByMlsNumberSubmit(queryId, v));
        },
      }}
    >
      {children}
    </SearchByMlsNumberContext.Provider>
  );
};
